/**
 * Main Application Component
 *
 * Entry point for the React application with providers
 */

import React from "react";
import { DesignSystemProvider } from "./contexts/DesignContext";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import AppRoutes from "./app/AppRoutes";

function App() {
  return (
    <DesignSystemProvider>
      <AuthProvider>
        <LanguageProvider>
          <AppRoutes />
        </LanguageProvider>
      </AuthProvider>
    </DesignSystemProvider>
  );
}

export default App;
